<template>
    <el-dialog class="dialog-order-info" :title="operation == 'add' ? '新增时段' : '编辑时段'" :visible.sync="dialogVisible"
        width="48%">
        <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
            <el-form-item label="开始时间 :" prop="startTime">
                <el-time-picker class="w-100" value-format="HH:mm" format="HH:mm" v-model="form.startTime"
                    placeholder="选择日期时间"></el-time-picker>
            </el-form-item>

            <el-form-item label="结束时间 :" prop="endTime">
                <el-time-picker class="w-100" value-format="HH:mm" format="HH:mm" v-model="form.endTime"
                    placeholder="选择日期时间"></el-time-picker>
            </el-form-item>

            <el-form-item label="开放票数 :" prop="openNum">
                <el-input v-model="form.openNum"></el-input>
            </el-form-item>

            <el-form-item class="session-form" label="开放场次 :" prop="openTimes">
                <el-checkbox-group v-model="openTimes">
                    <div class="week-item" v-for="week in weeks" :key="week.value">
                        <el-checkbox-button :label="week.value" :key="week.value">{{ week.label
                        }}</el-checkbox-button>
                        <span class="icon-span" @click="setGroup(week)"><i class="el-icon-check"></i></span>
                    </div>
                </el-checkbox-group>
            </el-form-item>
        </el-form>

        <div slot="footer" class="footer mt-30">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submit" type="primary" :loading="loadingSave">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        const validateOpenTime = (rule, value, callback) => {
            if (this.closeTimes && this.closeTimes.length == 0) {
                callback(new Error('开放场次不能为空'))
            } else {
                callback()
            }
        }

        return {
            dialogVisible: false,
            form: {
                orgId: this.$route.query.orgId,
                openTimes: '',
                startTime: '',
                endTime: '',
                openNum: null
            },
            operation: '',
            openTimes: [],
            weeks: [{ label: '周一', value: '1' }, { label: '周二', value: '2' }, { label: '周三', value: '3' }, { label: '周四', value: '4' }, { label: '周五', value: '5' }, { label: '周六', value: '6' }, { label: '周日', value: '7' }],
            openList: [{ label: '有票', value: '1' }, { label: '闭馆', value: '2' }, { label: '已满', value: '3' }],
            pageType: '',
            rules: {
                openTimes: [
                    { required: true, validator: validateOpenTime, trigger: 'blur' }
                ],
                openNum: [
                    { required: true, message: '开放票数不能为空', trigger: 'blur' }
                ],
                startTime: [
                    { required: true, message: '开始预约时间不能为空', trigger: 'blur' }
                ],
                endTime: [
                    { required: true, message: '停止预约时间不能为空', trigger: 'blur' }
                ]
            },
            listQuery: {
                currentPage: 1,
                size: 10
            },
            timeId: '',
            loadingSave: false,
            chooseRowIds: '' // 当前导出选中藏品id
        }
    },
    methods: {
        init(ope, id) {
            this.operation = ope
            if (id) {
                this.timeId = id
                this.getData()
            }
            this.dialogVisible = true
        },

        getData() {
            this.tableData = []
            this.$api.appointSetting.getTime({
                id: this.timeId
            }).then(res => {
                if (res.success) {
                    this.form = res.result
                    if (this.form.openTimes) {
                        this.openTimes = this.form.openTimes.split(',')
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        setGroup(obj) {
            if (this.openTimes.includes(obj.value)) {
                let index = this.openTimes.indexOf(obj.value);
                this.openTimes.splice(index, 1);
            } else {
                this.openTimes.push(obj.value)
            }

        },

        cancel() {
            this.$refs['form'].resetFields()
            this.form = {}
            this.openTimes = []
            this.dialogVisible = false
        },

        submit() {
            this.$refs['form'].validate(vaild => {
                if (vaild) {
                    let params = {
                        ...this.form,
                        openTimes: this.openTimes.join(','),
                    }
                    this.loadingSave = true
                    this.$api.appointSetting.saveTime(params).then(res => {
                        this.loadingSave = false
                        if (res.success) {
                            this.$message.success('保存成功')
                            this.$emit('refresh')
                            this.cancel()
                        } else {
                            this.$message.error(res.message || '系统异常')
                        }
                    }).catch(() => {
                        this.loadingSave = false
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.session-form {
    /deep/ .el-form-item__content {

        .el-checkbox-group {
            display: flex;

            .week-item {
                display: flex;
                margin-right: 10px;

                &:hover {
                    cursor: pointer;

                    .el-checkbox-button__inner {
                        color: $primary;
                    }

                    .el-icon-check {
                        font-size: 20px;
                        color: #d2d2d2;
                    }
                }

                .el-checkbox-button {
                    outline: none !important;

                    // margin-right: 10px;
                    &.is-checked {
                        .el-checkbox-button__inner {
                            background: $primary ;
                        }

                        &+.icon-span {
                            .el-icon-check {
                                font-size: 20px;
                                color: $primary;
                            }
                        }
                    }

                    .el-checkbox-button__inner {
                        height: 100%;
                        background: #d2d2d2;
                        color: #fff;
                        line-height: 40px;
                        padding: 0 10px;
                    }
                }

                .icon-span {
                    display: flex;
                    box-sizing: border-box;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #DCDFE6;
                    border-left: 0;
                    width: 40px;

                }
            }
        }

        .el-checkbox-button.is-focus .el-checkbox-button__inner {
            border-color: transparent !important;
        }
    }
}
</style>